<template class="app">
  <div  style=" display: flex; flex-direction: column">
<!--    <iframe :src="url" style="margin: auto; width: 100%; height: 800px;"/>-->
    <FrameIframe style="margin: auto; width: 100%; height: 800px;" v-if="fileId" :file-id="fileId" class="frame"></FrameIframe>
  </div>
</template>

<script>
export default {
  name: "InterviewPdfView",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data(){
    return{
      fileId:'',
      url:"",
      fileName:""
    }
  },
  methods:{
    async getFileUrl() {
      console.log('this.parentData:',this.parentData)
      let object = await this.$http('crmService.getFile', this.parentData)
      console.log('File URL:', object)
      this.fileId = object.id
      this.url = object.url
    }
  },
  created() {
    // if (this.parentData.quote_no){
    //   this.fileName = this.parentData.quote_no
    // }
    // if (this.parentData.contract_no){
    //   this.fileName = this.parentData.contract_no
    // }
    if (this.parentData.employee_name){
      this.fileName = this.parentData.employee_name
    }
    this.getFileUrl()
  }
}
</script>

<style scoped>
.app{
  width: 100%;
  height: 100%;
}

.frame {
  height: calc(100% - 8px);
  width: 100%;
}
</style>